import { Outlet } from "react-router-dom";
import { Header } from "../components/Header";
import { SideBar } from "../components/SideBar";
import useStore from "../store/useStore";
import { useEffect } from "react";
import { parseAuthToken } from "../utils/jwt";

export function MainLayout() {
  const { setUser } = useStore((state) => state);

  useEffect(() => {
    const userData = parseAuthToken();
    if (userData) {
      setUser(userData);
    }
  }, []);

  return (
    <div className="flex flex-col h-screen">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <SideBar />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
